import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import { EditCustomerContext, IEditCustomerContext } from '../../../../../../../editCustomerState/editCustomerContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		email,
		emailBodyTemplate,
		clientType,
		billTemplateFileData,
		billAdvertisingImageData,
		billAdvertisingImage,
		billAdvertisingLink,
		priceType,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		isShowLoyaltyProgramButtons,
		baseMcc,
		mccCards,
		mainMccCardBrand,
		mainMccCardMcc,
		vivaWalletCredentialsId,
		ads,
		stopListSyncIntervalMinutes,
		menuVersion,
		contentVersion,
		IDSelectedCustomerDefaultLanguage,
		IDsSelectedCustomerLanguages,
		filePath,
		tags,
		isActiveBpa,
		fileId,
		initialFormData,
	} = useContext<IEditCustomerContext>(EditCustomerContext);

	const containerClasses = classNames(style.container, {
		[style.visible]:
			name ||
			email ||
			emailBodyTemplate ||
			clientType ||
			billTemplateFileData.fileId ||
			billAdvertisingImageData.fileId ||
			billAdvertisingImage ||
			billAdvertisingLink ||
			priceType ||
			tips0 ||
			tips1 ||
			tips2 ||
			tips3 ||
			defaultTips ||
			isShowLoyaltyProgramButtons ||
			baseMcc ||
			mccCards ||
			mainMccCardBrand ||
			mainMccCardMcc ||
			vivaWalletCredentialsId ||
			ads ||
			menuVersion ||
			contentVersion ||
			IDSelectedCustomerDefaultLanguage ||
			IDsSelectedCustomerLanguages ||
			isActiveBpa,
	});

	const currentFormData = {
		name,
		email,
		emailBodyTemplate,
		clientType,
		billTemplateFileData,
		billAdvertisingImageData,
		billAdvertisingImage,
		billAdvertisingLink,
		priceType,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		isShowLoyaltyProgramButtons,
		baseMcc,
		mccCards: mccCards.map((el) => ({ brand: el.brand, mcc: el.mcc })),
		mainMccCardBrand,
		mainMccCardMcc,
		vivaWalletCredentialsId,
		ads,
		stopListSyncIntervalMinutes,
		menuVersion,
		contentVersion,
		IDSelectedCustomerDefaultLanguage,
		IDsSelectedCustomerLanguages,
		filePath: fileId || filePath || null,
		tags,
		isActiveBpa,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
